<template>
  <div class="stock-zero-import">

    <div class="dropzone bg-white" @dragover="dragover" @dragleave="dragleave" @drop="drop">
      <input type="file" name="fields[assetsFieldHandle_v][]" id="assetsFieldHandle_v" @change="onChange" ref="file" style="opacity: 0;display:none"/>
      <div v-if="!filelist.length" style="padding-top:10px;padding-left:25px;color:gray;display:flex;align-items:center;">
        <v-icon class="mdi mdi-file-upload-outline orange--text"></v-icon>
        <span style="padding-left:10px;">Stock Zero File Drop</span>
      </div>
    </div>

    <div style="display:flex;justify-content:space-between;align-items:center;margin-top:10px;position:relative;">
      <v-btn style="background:#ff7214;color:white;height:15px;width:75px;font-size:8px;margin-right:10px;" @click="pullData()">PULL DATA</v-btn>
      <div>
        <div style="font-size:10px;color:gray;font-style:italic;">File Date: {{lastUploadDate}}</div>
        <div style="font-size:10px;color:gray;font-style:italic;">Pull Date: {{lastPullDate}}</div>
      </div>
    </div>
  </div>
</template>

<script>
// import * as XLSX from "xlsx"
import Papa from "papaparse"
import firebase from 'firebase/compat/app';
import { mapGetters, mapActions } from 'vuex'
import Moment from 'moment'
import _ from 'lodash'
import AWS from 'aws-sdk';

export default {
  name: 'StockZeroImport',
  components: {

  },
  data(){
    return {
      filelist: []
    }
  },
  watch: {
    filelist(val){
      if(val.length > 0){
        this.readFiles()
      }
    }
  },
  computed: {
    ...mapGetters(['user','db']),
    lastUploadDate(){
      return this.db.last_stock_zero_file_upload ? Moment(this.db.last_stock_zero_file_upload).format('MM/DD/YY hh:mma') : false
    },
    lastPullDate(){
      return this.db.last_stock_zero_file_pull ? Moment(this.db.last_stock_zero_file_pull).format('MM/DD/YY hh:mma') : false
    }
  },
  methods: {
    async pullData(){
      AWS.config.region = 'us-east-1';

      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: 'us-east-1:44b121e3-3117-4e3a-b0b1-a9ea0abf7772',
      });

      AWS.config.credentials.get(() => {
        const s3 = new AWS.S3();

        const params = {
          Bucket: 'cloudmailing-files',
          Prefix: 'stock-zero/'
        };

        s3.listObjectsV2(params, (err, data) => {
          if (err) {
            console.error(err);
          } else {
            const files_arr = data['Contents'].sort((a, b) => (a.LastModified < b.LastModified) ? 1 : ((b.LastModified < a.LastModified) ? -1 : 0));
            const fileKey = files_arr[0].Key;
            const s3Params = { Bucket: 'cloudmailing-files', Key: fileKey };

            var most_recent_file_date = Moment(new Date(files_arr[0].LastModified));
            var today_date = Moment(new Date());
            var is_same_day = most_recent_file_date.isSame(today_date, 'day');
            var shouldProceed = is_same_day;
            var file_date = Moment(files_arr[0].LastModified, 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)').valueOf();

            if (!is_same_day) {
                var msg = 'This file is from ' + most_recent_file_date.format('MM-DD-YYYY') + '. Today\'s file has not loaded to the cloud yet. Do you want to proceed with loading the older file?'
                shouldProceed = confirm(msg);
            }

            if (shouldProceed) {
              s3.getObject(s3Params, (err, data) => {
                if (err) {
                  console.error(err);
                } else {
                  const file = new File([data.Body], fileKey);
                  this.writeInitialData(file,file_date);
                }
              });
            }
          }
        });
      });
    },
    searchFiles(){
      document.getElementById("assetsFieldHandle_v").click()
    },
    onChange() {
      var files_arr = [...this.$refs.file.files];
      files_arr = _.sortBy(files_arr, (obj) => parseInt(obj.name, 10));
      this.filelist = files_arr;
    },
    remove(i) {
      this.filelist.splice(i, 1);
    },
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains('bg-orange')) {
        event.currentTarget.classList.remove('bg-white');
        event.currentTarget.classList.add('bg-orange');
      }
    },
    dragleave(event) {
      event.currentTarget.classList.add('bg-white');
      event.currentTarget.classList.remove('bg-orange');
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      event.currentTarget.classList.add('bg-white');
      event.currentTarget.classList.remove('bg-orange');
      this.onChange();
    },
    readFiles(){
      for(var i = 0; i < this.filelist.length; i++){
        var file_name = this.filelist[i].name.toLowerCase()
        if(this.filelist[i].type.indexOf('text/csv') !== -1 && file_name.indexOf('stock') !== -1){
          this.writeInitialData(this.filelist[i], Date.now())
        }else{
          this.$store.state.isLoading = false
          this.remove(this.filelist[i])
          alert("Invalid File - File name must contain 'stock'")
        }
      }
    },
    writeInitialData(file,file_date){
      var reader = new FileReader();
      var self = this
      self.$store.state.isLoading = true
      reader.readAsBinaryString(file);

      reader.onload = function(e) {
        var data = e.target.result;
        var parsedData = Papa.parse(data, {
          header: true, // Set header to true to parse the first row as headers
          dynamicTyping: false, // Disable automatic type casting
          skipEmptyLines: true, // Skip empty lines
        });

        var json = parsedData.data;

        if (json.length === 0) {
          self.$store.state.isLoading = false;
          alert('Invalid File(s)');
          return;
        }

        setTimeout(function(){
          self.updateDatabase(json,file_date)
        },1000)
      }
    },
    async updateDatabase(json,file_date){
      var self = this;
      var db_object = {};
      var new_ids_set = new Set();

      var current_db_stock_zero_clone = self.db.stock_zero ? JSON.parse(JSON.stringify(self.db.stock_zero)) : {}

      var date = Date.now()

      for (var i = 0; i < json.length; i++) {
        var row_data = json[i];
        var unique_id = row_data['Product (25)'].replace(/[^0-9a-z]/gi, '');
        
        new_ids_set.add(unique_id); // Track all new IDs

        var line_info = {
          'product': row_data['Product (25)'] || '',
          'description_full': row_data['Description Full'] || '',
          'primary_vendor': row_data['Primary Vendor'] || '',
          'product_line_code': row_data['Product Line Code'] || '',
          'width': row_data['Width'] || '',
          'whse_1_onpo': row_data['Whse 1 OnPO'] || '',
          'total_qty_bo': row_data['Total Qty BO'] || '',
          'substitute_1': row_data['Substitute 1'] || '',
          'substitute_2': row_data['Substitute 2'] || '',
          'substitute_3': row_data['Substitute 3'] || '',
          'substitute_4': row_data['Substitute 4'] || '',
          'substitute_5': row_data['Substitute 5'] || '',
          'whse_minimums': row_data['Whse Minimums'] || '',
          'whse_maximums': row_data['Whse Maximums'] || '',
          'hits': row_data['Hits'] || '',
          'demand': row_data['Demand'] || '',
          'quarterly_projected_usage': row_data['Quarterly Projected Usage'] || '',
          'available_wh_01': row_data['Available Wh 01'] || '',
          'upload_date': date,
          'upload_by': self.user,
          'unique_id': unique_id
        };

        if (current_db_stock_zero_clone[unique_id]) {
          db_object[unique_id] = { ...current_db_stock_zero_clone[unique_id], ...line_info }; // Preserve existing custom fields
        } else {
          line_info.first_upload_date = date
          db_object[unique_id] = line_info;
        }
      }

      // Delete removed entries
      const deletions = {};
      for (let existing_id in current_db_stock_zero_clone) {
        if (!new_ids_set.has(existing_id)) {
          deletions[existing_id] = null; // Firebase uses `null` to delete keys
        }
      }

      if (Object.keys(deletions).length > 0) {
        await firebase.database().ref('stock_zero').update(deletions);
      }

      await this.chunkAndUpload(db_object);
      await firebase.database().ref('last_stock_zero_file_upload').set(file_date);
      await firebase.database().ref('last_stock_zero_file_pull').set(Date.now())

      self.filelist = [];
      self.$store.state.isLoading = false;
    },
    async chunkAndUpload(db_object) {
      const entries = Object.entries(db_object);
      const chunkSize = 5000;

      for (let i = 0; i < entries.length; i += chunkSize) {
        const chunk = Object.fromEntries(entries.slice(i, i + chunkSize));
        await firebase.database().ref('stock_zero').update(chunk);
        console.log(`Uploaded chunk ${i / chunkSize + 1} of ${Math.ceil(entries.length / chunkSize)}`);
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }    
  }
}
</script>

<style scoped>
  .dropzone{
    width: 100%;
    height: 50px;
    border: 2px dashed orange;
    border-radius: 4px;
  }
  .bg-white{
    background: white;
  }
  .bg-orange{
    background: orange;
  }
</style>
